import { render, staticRenderFns } from "./FindingsTable.vue?vue&type=template&id=5774b74a"
import script from "./FindingsTable.vue?vue&type=script&lang=js"
export * from "./FindingsTable.vue?vue&type=script&lang=js"
import style0 from "./FindingsTable.vue?vue&type=style&index=0&id=5774b74a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports